import styles from './PageProgressSpinner.module.scss';

export const PageProgressSpinner = () => (
  <div className={styles.container}>
    <div className={styles.spinner}></div>
  </div>
);

export default PageProgressSpinner;
